import s from './CollapsibleHeader.module.css';
import { type LanguageCore, Text } from '../Language/Language';

export const CollapsibleHeader = ({
  language,
  id,
}: {
  language: LanguageCore;
  id: string;
}) => (
  <h2 id={id} className={s.title}>
    <Text {...language} />
  </h2>
);
